import { createThemeCompiler } from '../../../utils';

export const checkboxThemeCompiler = createThemeCompiler(({ palette, borderRadius }) => ({
    checkbox: {
        colors: {
            checked: {
                backgroundColor: palette.themePrimary,
                borderColor: palette.themePrimary,
                checkMarkColor: palette.white
            },
            default: {
                backgroundColor: palette.white,
                borderColor: '#676E7B',
                checkMarkColor: ''
            },
            disabled: {
                backgroundColor: palette.white,
                borderColor: '#CACED5',
                checkMarkColor: ''
            },
            disabledAndChecked: {
                backgroundColor: '#EFF0F1',
                borderColor: '#CACED5',
                checkMarkColor: '#676E7B'
            },
            error: {
                backgroundColor: palette.white,
                borderColor: palette.red,
                checkMarkColor: palette.white
            },
            errorAndChecked: {
                backgroundColor: palette.themePrimary,
                borderColor: palette.red,
                checkMarkColor: palette.white
            },
            hovered: {
                backgroundColor: palette.white,
                borderColor: palette.themePrimary,
                checkMarkColor: palette.transparent
            }
        },
        composites: {
            borderRadius: borderRadius.curvedXSmall,
            groupCheckboxGap: 25
        }
    }
}));
